import styled, { keyframes } from 'styled-components';

const draw = keyframes`
    to {
        stroke-dashoffset: 0;
    }
`;

const pulseFade = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.2;
    }
    100% {
        opacity: 1;
    }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  animation: ${pulseFade} 1.5s ease-in-out infinite;
`;

export const StyledSVG = styled.svg<{ size: number }>`
  width: ${({ size }) => size}px;
  height: auto;
    stroke-linecap: round;
    stroke-linejoin: round; 
  .contour {
    fill: #fff;
    stroke: black;
    stroke-width: .4;
    stroke-dasharray: 100;
    stroke-dashoffset: 800;
      stroke-linecap: round;
      stroke-linejoin: round;
      animation: ${draw} 9s linear infinite;
  };
`;
